export const FREE_SHIPPING_COUNTRIES = ['US'];
export const TRUEMED_COUNTRIES = ['US'];
export const TAX_INCLUDED_COUNTRIES = [
  'AX',
  'AL',
  'AD',
  'AM',
  'AW',
  'AU',
  'AT',
  'BE',
  'BA',
  'BR',
  'BG',
  'BQ',
  'CN',
  'CK',
  'HR',
  'CW',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FK',
  'FI',
  'FR',
  'GM',
  'GE',
  'DE',
  'GI',
  'GR',
  'GL',
  'GP',
  'GG',
  'HU',
  'IS',
  'IN',
  'ID',
  'IE',
  'IM',
  'IT',
  'JP',
  'JE',
  'XK',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MU',
  'YT',
  'MC',
  'ME',
  'MA',
  'NL',
  'NZ',
  'NU',
  'NO',
  'PL',
  'PT',
  'RE',
  'MD',
  'RO',
  'BL',
  'MF',
  'SM',
  'SN',
  'RS',
  'SG',
  'SK',
  'SI',
  'ES',
  'SJ',
  'SE',
  'CH',
  'TR',
  'UA',
  'GB',
  'VU',
];
